<template lang="html">
  <div class="here-to-help-container mt-5">
    <div class="here-to-help-bg">
      <img src="../../assets/img/mag-glass.svg" alt="">
    </div>
    <div class="here-to-help-text">
      <h2>WE’RE HERE TO HELP</h2>
      <p>We understand the feelings of anxiety and fear when things get itchy or hurting. Hell, we’ve been there ourselves.</p>

      <p>We also know how nerve-racking, time and money consuming - or even flat out traumatic sometimes - the visit to a doctor can be. From booking an appointment and going through a series of uncomfortable and painful exams to the desensitized approach of seasoned physicians and the endless waiting to get back results, it’s no wonder women tend to avoid going through this ordeal as much as possible.</p>

      <p>So, we get it. You want to find out if there’s something wrong swiftly, inexpensively, and painlessly. But Googling your symptoms and scanning thousands of results in an attempt to find credible information isn’t always the best option - and could end up with you misdiagnosing yourself.</p>

      <p>That’s where HappyG comes in.</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  .here-to-help-container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
    grid-gap: 1em;
  }
  .here-to-help-bg {
    grid-column: 1/13;
    grid-row: 1/1;
    align-self: center;
  }
  .here-to-help-text {
    grid-column: 2/12;
    grid-row: 2;
    text-align: left;
  }

  @media (min-width: 1200px) {
    .here-to-help-bg {
      grid-column: 1/13;
      grid-row: 1/12;
      align-self: left;
    }
    .here-to-help-text {
      grid-column: 7/11;
      grid-row: 6;
      text-align: left;
    }
    .here-to-help-container {
    }
  }
</style>
